(function () {
  'use strict';

  angular
    .module('admin.sets.waitlist', ['admin.sets.waitlist.service'])
    .controller('AdminSetsWaitlistCtrl', AdminSetsWaitlistCtrl);

  /** @ngInject */
  function AdminSetsWaitlistCtrl($stateParams, AdminSetsWaitlistService) {
    var vm = this;
    vm.items = [];
    vm.perPage = 25;

    function reloadPagination() {
      vm.totalItems = 0;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      AdminSetsWaitlistService.list($stateParams.id, vm.oldPage, 25, 'username-asc').then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        vm.items = result.results;
      });
    };

    load(1);

    vm.load = function () {
      reloadPagination();
      load(1);
    };

    vm.pageChanged = function (newPage) {
      load(newPage);
      $("html, body").animate({ scrollTop: 0 }, 0);
    };
  }

})();
